import { Badge, Button, Card, Group, Stack, Text, Title } from '@mantine/core';
import { IconTag } from '@sloyd/icons';
import classnames from 'classnames';
import { Flex, Wrapper } from './OrderGenerator.style';

export type OrderGeneratorProps = {
  spawn: boolean;
  onCta: () => void;
};

export function OrderGenerator(props: OrderGeneratorProps) {
  const { spawn } = props;

  const className = classnames('OrderGenerator-wrapper', {
    spawn,
  });

  return (
    <Wrapper className={className} data-testid='OrderGenerator-wrapper'>
      <Card shadow='md' padding='md' radius='lg' withBorder onClick={props.onCta}>
        <Group justify='space-between' mb='xs'>
          <Title order={spawn ? 5 : 4}>Custom</Title>
          {!spawn && (
            <Badge color='pink' size='md' variant='light'>
              On Sale
            </Badge>
          )}
        </Group>

        <Stack spacing='xs' mt='sm' mb='md'>
          {spawn ? (
            <Text size='sm' c='dimmed'>
              Not seeing what you need? Let us whip up a custom generator.
            </Text>
          ) : (
            <Text size='sm' c='dimmed'>
              Not seeing what you need? Let us whip up a custom generator, tailored to you and ready
              in no time.
            </Text>
          )}
        </Stack>
        <Flex />

        <Button
          variant='gradient'
          gradient={{ deg: 60, from: 'pink', to: 'yellow' }}
          leftSection={<IconTag size={18} />}
          fullWidth
          radius={spawn ? 'md' : 'xl'}
          size={spawn ? 'xs' : 'sm'}
          data-track
        >
          Order Now
        </Button>
      </Card>
    </Wrapper>
  );
}

export default OrderGenerator;
